import type { Component } from 'vue'
import type { PlatformSurfaceRegistration } from './contracts'

const registrations = new Map<string, PlatformSurfaceRegistration>()

export function registerPlatformSurface(registration: PlatformSurfaceRegistration): () => void {
	const key = registration.surfaceKey.trim()
	if (!key)
		throw new Error('Platform surface_key is required')
	if (registrations.has(key))
		throw new Error(`Platform surface ${key} is already registered`)
	if (Boolean(registration.component) === Boolean(registration.loadComponent))
		throw new Error(`Platform surface ${key} must declare exactly one component source`)

	registrations.set(key, { ...registration, surfaceKey: key })
	return () => registrations.delete(key)
}

export function getPlatformSurface(surfaceKey: string): PlatformSurfaceRegistration | null {
	return registrations.get(surfaceKey.trim()) ?? null
}

export async function resolvePlatformSurfaceComponent(surfaceKey: string): Promise<Component> {
	const registration = getPlatformSurface(surfaceKey)
	if (!registration)
		throw new Error(`Platform surface ${surfaceKey} is not registered in this client build`)

	if (registration.component)
		return registration.component
	const loaded = await registration.loadComponent!()
	return ('default' in (loaded as object) ? (loaded as { default: Component }).default : loaded) as Component
}

export function listPlatformSurfaces(): PlatformSurfaceRegistration[] {
	return Array.from(registrations.values())
}
